import { Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { formatDuration } from '@scisys-uim/uim-common';

@Component({
  selector: 'app-login-failed-dialog',
  templateUrl: './login-failed-dialog.component.html',
  styleUrls: ['./login-failed-dialog.component.scss']
})
export class LoginFailedDialogComponent {

  private _lockedUntilUnixTime: number;

  constructor(protected dialogRef: MatDialogRef<LoginFailedDialogComponent, string>,
    @Inject(MAT_DIALOG_DATA) protected data: any,
    protected fb: FormBuilder) {
  }

  get error(): any {
    return this.data?.error;
  }
  get isCodeInvalid(): boolean {
    return !!this.error?.error?.codeInvalid;
  }
  get lockedUntilText(): any {
    return this.error?.error?.lockedUntil;
  }
  get lockedUntilUnixTime(): any {
    if (this._lockedUntilUnixTime == null && this.lockedUntilText != null) {
      this._lockedUntilUnixTime = new Date(this.lockedUntilText).getTime();
    }
    return this._lockedUntilUnixTime;
  }
  get lockedForDurationMillis(): number {
    var lockedUntilUnixTime = this.lockedUntilUnixTime;
    if (lockedUntilUnixTime == null) {
      return null;
    }
    return new Date(this.lockedUntilText).getTime() - new Date().getTime();
  }

  get lockedUntilDurationDisplay(): string {
    var lockedForDurationMillis = this.lockedForDurationMillis;
    if (lockedForDurationMillis == null) {
      return null;
    }
    return formatDuration(lockedForDurationMillis);
  }

  close() {
    this.dialogRef.close()
  }
}
